module.exports = __webpack_public_path__ + "static/media/11NEPAD9.d6d20615.jpg";